// Paged admin API responses (server opt-in pagination): with ?limit the list endpoints
// return { items, total }; without params they return the legacy bare array.
// This helper accepts either shape, so the dashboard tolerates a server on
// either side of the rollout.
export const PAGE_SIZE = 200;

export function pagedItems<T>(data: unknown): { items: T[]; total: number } {
  if (Array.isArray(data)) return { items: data as T[], total: data.length };
  const obj = (data || {}) as { items?: unknown; total?: unknown };
  const items = Array.isArray(obj.items) ? (obj.items as T[]) : [];
  const total = typeof obj.total === "number" ? obj.total : items.length;
  return { items, total };
}
